/**
 * Live VE Student ID from the enrollment fields the user has filled.
 */
export default function SuggestedStudentIdHint({
  studentId = '',
  unixUsername = '',
  onUse,
  showUse = false,
}) {
  const id = String(studentId || '').trim();
  const unix = String(unixUsername || '').trim();

  if (!id) {
    return (
      <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
        Suggested Student ID appears after program type, mode, and center (offline) are filled.
      </p>
    );
  }

  return (
    <div
      className="rounded-lg px-3 py-2 text-sm space-y-1"
      style={{
        backgroundColor: 'var(--color-background, transparent)',
        border: '1px dashed var(--color-border)',
      }}
    >
      <p style={{ color: 'var(--color-text)' }}>
        Suggested Student ID:{' '}
        <span className="font-mono font-semibold">{id}</span>
        {showUse && typeof onUse === 'function' ? (
          <button
            type="button"
            onClick={onUse}
            className="ml-2 underline text-xs"
            style={{ color: 'var(--color-primary)' }}
          >
            Use this ID
          </button>
        ) : null}
      </p>
      {unix ? (
        <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
          Unix username: <span className="font-mono">{unix}</span>
        </p>
      ) : (
        <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
          Next free ID for the program, mode, and center you selected.
        </p>
      )}
    </div>
  );
}
